import { Component, inject, input } from '@angular/core';

import { BaseDeleteButtonComponent } from '../../../../../shared/base-classes/base-delete-button.component';
import { UltraMenuItemComponent } from '../../../../../shared/components/ultramarine-ui/ultra-menu-item/ultra-menu-item.component';
import { UltraMenuItemWrapperComponent } from '../../../../../shared/components/ultramarine-ui/ultra-menu-item-wrapper/ultra-menu-item-wrapper.component';
import { DialogsService } from '../../../../../shared/services/dialogs.service';
import { VehiclesService } from '../../vehicles.service';

@Component({
	selector: 'app-vehicle-delete-button',
	templateUrl: 'vehicle-delete-button.component.html',
	imports: [UltraMenuItemWrapperComponent, UltraMenuItemComponent],
})
export class VehicleDeleteButtonComponent extends BaseDeleteButtonComponent {
	private _vehiclesService = inject(VehiclesService);
	private _dialogsService = inject(DialogsService);

	licensePlate = input<string>();

	onDelete() {
		this._dialogsService.openDeleteRecordDialog(
			{
				confirmed: () => {
					this._vehiclesService.deleteRecord(this.id()).subscribe((res) => {
						this.onDeleteCalled.emit(res);
					});
				},
			},
			this.licensePlate(),
		);
	}
}
